<script>
import VuexProps from "@/framework/vuex/VuexProps";
import AlertDialogBuilder from "@/assets/plugins/mps-dialog/AlertDialogBuilder";
import {PATH} from "@/constants";
import Work from "@/model/work";

export default {
  name: "CapacitorMixin",
  mixins: [VuexProps],
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.setUpPushFcm()
  },
  beforeDestroy() {
  },
  methods: {
    /**
     * capacitor로 제작된 모바일 App의 FCM 토큰 정보 관리
     */
    setUpPushFcm() {
      if (this.$capacitorPlugin.isCapacitorMobileApp) {
        const {PushNotifications, LocalNotifications} = window.Capacitor.Plugins || {}

        if (!PushNotifications) {
          return
        }

        PushNotifications.addListener('registration', async (token) => {
          if (!!this.$userManager.user && !!this.$userManager.user.userId) {
            const deviceInfo = await this.$capacitorPlugin.getDeviceInfo()
            if (deviceInfo.deviceId && deviceInfo.deviceType) {
              await this.$userManager.sendTokenToServer2(token.value, deviceInfo.deviceType, deviceInfo.deviceId)
            }
          }
        })
        
        window.addEventListener('capacitorPushNotificationRegistration', async (event) => {
          if (!!this.$userManager.user) {
            this.$userManager.sendSavedPushTokenAfterLogin()
          }
        })

        PushNotifications.addListener('registrationError', (error) => {
          console.error('Push notification registration error:', error)
        })

        PushNotifications.addListener('pushNotificationReceived', (notification) => {
          console.info('pushNotificationReceived > notification: ', notification)
          this.showDialogNotificationForCapacitor(notification.data)
          this.$capacitorPlugin.showNotification(notification)
        })

        PushNotifications.addListener('pushNotificationActionPerformed', (event) => {
          console.info('pushNotificationActionPerformed > event: ', event)
          this.showDialogNotificationForCapacitor(event.notification.data)
        })

        PushNotifications.checkPermissions().then(result => {
          if (result.receive === 'granted') {
            // 이미 권한이 있으면 등록만 함
            PushNotifications.register()
            return
          } else if (result.receive === 'denied') {
            // 이미 거부되었으면 요청하지 않음
            return
          }
          
          // 권한이 결정되지 않았을 때만 요청
          PushNotifications.requestPermissions().then(async result => {
            if (result.receive === 'granted') {
              PushNotifications.register()
            }
          }).catch(error => {
            console.error('Push notification request permissions error:', error)
          })
        }).catch(error => {
          console.error('Push notification checkPermissions error:', error)
        })
      }
    },

    /**
     * App Push 수신시 화면에 띄워줄 다이얼로그
     * @param data
     */
    showDialogNotificationForCapacitor(data) {
      if (!this.$userManager.user) {
        this.$capacitorPlugin.putPayLoad(data)
        return
      }

      setTimeout(() => {
        const payload = data;
        switch (payload.domain) {
          case 'WORK':
            // 작업 상태 변경 다이얼로그
            this.showDialogWork(payload);
            break;
          case 'WORK_SEQUENCE':
            // 작업 순서 변경 다이얼로그
            this.showDialogWorkSequence(payload);
            break;
        }
      }, 100);
    },

    showDialogWork(payload) {
      let message = payload.content;
      let title = payload.title;
      const builder = new AlertDialogBuilder(this.$mps_dialog_event_bus);
      builder
        .title(title)
        .message(message)
        .buttonNegative(this.$translate('상세보기'), () => {
          this.routerManager.push({name: "AsDetailForPush", params: {workorderId: payload.workorderId,}});
        });
      // 작업 상태에 따른 다이나믹 액션 버튼을 만듭니다.
      switch (payload.workorderState) {
        case "1":
        case "2":
          builder.buttonPositive(this.$translate('수락'), () => {
            this.$request(PATH.WORK_ORDER.DETAIL)
              .setObject({
                workorderId: payload.workorderId,
                asId: payload.asId,
              })
              .enqueue()
              .then(res => {
                new Work(res).accept(); // 수락 기능 수행
              });
          });
          break;
        case "3":
        case "4":
        case "5":
        case "6":
          break;
      }
      builder
        .build()
        .show();
    },
    showDialogWorkSequence(payload) {
      let title = '작업 순서 변경';
      let message = '{0}님 작업 순서가 변경되었습니다.';
      this.$alert(this.$formatTranslation(message, payload.userFullname));
    },

  },
}
</script>
